import imageBank from './directives/imagebank';
import uploadImagesArea from './directives/upload-image-area';
import backgroundImage from './directives/background-image';
import makeDraggable from './directives/draggable-image';
import imageEditor from "./directives/image-editor";
import ImageEditorCtrl from "./image-editor.controller";
import imageDirectory from './directives/image-directory';
import ImageBankCtrl from './imagebank.controller';
import ImageBank from './imagebank.repository';
import uirouter from 'angular-ui-router';

export default angular.module('app.imagebank', [uirouter])
    .controller('ImageBankCtrl', ImageBankCtrl)
    .controller('ImageEditorCtrl', ImageEditorCtrl)
    .directive('backgroundImage', () => new backgroundImage)
    .directive('imageDirectory', () => new imageDirectory)
    .directive('imageBank', () => new imageBank)
    .directive('makeDraggable', () => new makeDraggable)
    .directive('uploadImagesArea', () => new uploadImagesArea)
    .directive('imageEditor', () => new imageEditor)
    .service('ImageBank', ImageBank)
    .name;